import { DRESSAGE_PLACING_CLASS_TYPES, TIE_BREAK_REASONS, isJudgeEnteredPlacingClassType } from "score-common";

// #3261 AC5 -- why a fully-FINAL, still-unplaced class needs a human to place
// it. These are exactly the cases the backend auto-placer (#3262) refuses to
// write, judged here with the same score-common suggestion engine so the page
// and the auto-placer agree:
//   - a tie the class type's chain does not break (DR123.3 "must remain tied")
//   - a judge-entered class (Equitation DR133.1, Medal DR133.2, DSHB
//     placement-only DR204.2.c / DR210.5) where a ride has no Place from the
//     judge, or two rides share one
//   - a Medal tie that needs a ride-off (DR133.2.g.5)
// Display only: nothing here is read by any write path.
export const NEEDS_HUMAN_REASONS = {
  UNBROKEN_TIE: "unbrokenTie",
  JUDGE_PLACE_MISSING: "judgePlaceMissing",
  JUDGE_PLACE_SHARED: "judgePlaceShared",
  RIDE_OFF_OWED: "rideOffOwed",
};

const isRealPlace = (v) => typeof v === "number" && Number.isInteger(v) && v > 0;

/**
 * @param {object} args
 * @param {Array<Array<object>>} args.groups placeable (non-term'd) result rows, one array per
 *   standing (one per division when the class is grouped, else a single array). A shared judge
 *   place only counts within a standing: two divisions each have their own 1st.
 * @param {Map<*, {tieGroup: Array, tiedReason: string|null}>} args.suggestions rideId -> suggestion
 * @param {string} args.classType a DRESSAGE_PLACING_CLASS_TYPES value
 * @returns {string|null} a NEEDS_HUMAN_REASONS value, or null when a human is not needed
 */
export function placingNeedsHumanReason({ groups, suggestions, classType }) {
  const tiedSuggestions = [...suggestions.values()].filter((s) => s.tieGroup.length > 1);

  if (isJudgeEnteredPlacingClassType(classType)) {
    const rows = groups.flat();
    if (rows.some((r) => !isRealPlace(r.judgeEnteredPlace))) {
      return NEEDS_HUMAN_REASONS.JUDGE_PLACE_MISSING;
    }
    const medal = classType === DRESSAGE_PLACING_CLASS_TYPES.EQUITATION_MEDAL;
    if (medal && tiedSuggestions.some((s) => s.tiedReason === TIE_BREAK_REASONS.RIDE_OFF_REQUIRED)) {
      return NEEDS_HUMAN_REASONS.RIDE_OFF_OWED;
    }
    for (const group of groups) {
      const seen = new Set();
      for (const r of group) {
        if (seen.has(r.judgeEnteredPlace)) return NEEDS_HUMAN_REASONS.JUDGE_PLACE_SHARED;
        seen.add(r.judgeEnteredPlace);
      }
    }
    return null;
  }

  return tiedSuggestions.length > 0 ? NEEDS_HUMAN_REASONS.UNBROKEN_TIE : null;
}
